export default "__VITE_ASSET__B61sUCP8__";